import graphql from "babel-plugin-relay/macro";
import { useAtomValue, useSetAtom } from "jotai";
import { useFragment } from "react-relay";

import { DropdownSelect } from "@whoosh/design-system/src/components/controls";
import { VStack } from "@whoosh/design-system/src/components/primitive";

import { useGetGolfPlayerRateOptions } from "../../../../../../../../../hooks/useGetGolfPlayerRateOptions";
import { setRateIdOnRoundAtom } from "../../../../../../atoms/actions/setRateIdOnRoundAtom/setRateIdOnRoundAtom";
import { getCourseLayoutHoleCountOnRoundAtom } from "../../../../../../atoms/selectors/getCourseLayoutHoleCountOnRoundAtom/getCourseLayoutHoleCountOnRoundAtom";
import { getRateOnRoundAtom } from "../../../../../../atoms/selectors/getRateOnRoundAtom/getRateOnRoundAtom";
import { selectedRoundAtom } from "../../../../../../atoms/stores";
import { ConfigureRoundGolfPlayerRateControl_Booking$key } from "./__generated__/ConfigureRoundGolfPlayerRateControl_Booking.graphql";

type Props = {
  bookingRef: ConfigureRoundGolfPlayerRateControl_Booking$key | null;
};

export const ConfigureRoundGolfPlayerRateControl = ({ bookingRef }: Props) => {
  const booking = useFragment(
    ConfigureRoundGolfPlayerRateControlFragmentString,
    bookingRef
  );
  const currentRate = useAtomValue(getRateOnRoundAtom);
  const currentRateId = currentRate?.id;
  const setRateIdOnRound = useSetAtom(setRateIdOnRoundAtom);
  const selectedRound = useAtomValue(selectedRoundAtom);
  const currentHoleCount = useAtomValue(getCourseLayoutHoleCountOnRoundAtom);
  const isCurrentRateLocked = currentRate?.isLocked ?? false;
  const dropdownOptions = useGetGolfPlayerRateOptions({
    bookingRef: booking ?? null,
    round: selectedRound,
    holeCount: currentHoleCount,
  });

  return dropdownOptions.length > 0 ? (
    <VStack flex={1}>
      <DropdownSelect
        hideOuterMargin
        isViewOnly={isCurrentRateLocked}
        hideChevron
        includeLeftElementInSelectedValue
        contentSizeOverride="regular"
        options={dropdownOptions}
        value={currentRateId}
        onChange={(rateId) => {
          setRateIdOnRound({
            rateId,
          });
        }}
      />
    </VStack>
  ) : null;
};

const ConfigureRoundGolfPlayerRateControlFragmentString = graphql`
  fragment ConfigureRoundGolfPlayerRateControl_Booking on Booking {
    ...useGetGolfPlayerRateOptions_Booking
  }
`;
